import { AppMountPoints } from '@apps/AppMounts'
import ActivationMount from '@sites/consumer/activation/ActivationMount'

const SiteMounts = {
  [AppMountPoints.activationMount]: ActivationMount
}

export default SiteMounts
